const MODEL_NAME = 'setting'
export default [
  {
    path: `/${MODEL_NAME}/recommend`,
    name: 'recommendSetting',
    component: () =>
      import(/* webpackChunkName: "setting-recommend" */ '@pages/setting/recommend/index.vue')
  },
  {
    path: `/${MODEL_NAME}/privacy`,
    name: 'privacySetting',
    component: () =>
      import(/* webpackChunkName: "setting-privacy" */ '@pages/setting/privacy/index.vue')
  },
  {
    path: `/${MODEL_NAME}/user-info`,
    name: 'userInfo',
    component: () =>
      import(/* webpackChunkName: "setting-userInfo" */ '@pages/setting/userInfo/index.vue')
  },
  {
    path: `/${MODEL_NAME}/export-user-info-success`,
    name: 'exportUserInfoSuccess',
    component: () =>
      import(/* webpackChunkName: "setting-userInfo" */ '@pages/setting/userInfo/exportSuccess.vue')
  }
]
